exports.urls = {
  // baseUrl: 'http://mazad.fatoorah.sa/api'
  baseUrl: 'https://backendmazad.almaharh.com/api'
};
